export default {
  UPCOMING: 'UPCOMING',
  DRAFT: 'DRAFT',
  OVERDUE: 'OVERDUE',
  ALL: 'ALL',
} as const
